import { getFromLocalStorage } from '../../hooks/useLocalStorage';
import { UPDATE_POLICY_PAYLOAD, UPDATE_POLICY_PAYLOAD_RESET, UPDATE_POLICY_PAYLOAD_SUCCESS } from '../actionTypes'


export const policyInitialState = {
    generateQuote: {
        company_id:'',
        policyType: '',
        geographical_cover: '',
        geographicalCoverId: '',
        geo_country: [],
        startDate: '',
        endDate: '',
        noOfDays: '',
        proposer_passport_number: '',
        proposer_dob: '',
        proposer_gender: '',
        proposer_title: '',
        proposer_first_name: '',
        proposer_middle_name: '',
        proposer_last_name: '',
        travellers: [],
        nominee: [],
        plan_id: '',
        plan_name: '', 
        plan_cover: '',
        plan_cost: '',
        plan_basic_cost: '',
        plan_coi: '',
        addonCost: '',
        addons: [],
        same_as_proposer: '',
        trip_duration: '',
        pricing_base_premium: '',
        pricing_addons_premium: '',
        pricing_msc_percent: '',
        pricing_msc_amount: '',
        pricing_discount_percent: '',
        pricing_discount_amount: '',
        pricing_new_base_premium: '',
        pricing_new_addons_premium: '',
        pricing_total_premium: '',
        pricing_gst_percent: '',
        pricing_gst_amount: '',
        pricing_member_premium: '',
        partnership_id:'',
        created_by_role_id: '',
        created_by_role: ''
    },
    travellerDetails: {
        proposer_pin_code: '',
        proposer_country: '',
        state: '',
        city: '',
        gender: '',
        proposer_address: '',
        proposer_email: '',
        proposer_mobile: '',
        proposer_pan: '',
        quotation_number: '',
        travelCareMembershipNo: '',
        
        // same_as_proposer: false,
        // pre_existing_disease: false,
    },

    // product: { product_id: '', product_name: '', sales_category_id: '', amount: 0 , policyId: '',product_details: {},products: [] },
    // payment_mode: '',
    // payment_amount: '',
    // user_id: '',
    // policyId: '',
    // hash: '',
    // txnid: '',
}

export default (state = policyInitialState, action) => {
    switch (action.type) {
        case UPDATE_POLICY_PAYLOAD:
            return { ...state, ...action.payload?.policy };
        case UPDATE_POLICY_PAYLOAD_SUCCESS:
            return { ...state, ...action.payload };
        case UPDATE_POLICY_PAYLOAD_RESET:
            return { ...state, ...policyInitialState };
        default: return state;
    }

}